import { archiveRegex } from './Constant';

// Derived series, not a data parameter (chart.js defaultCombinedParameterName).
const COMBINED_PARAMETER_NAME = 'Combined Z-score';

// "Initial Assessment, samples (n)" (`initialAssessment`) lives on the CHART
// GROUP config (per shortKey), so a change affects every parameter in the group.
// Saving the Configuration tab re-runs runData for the chart being viewed; that
// run re-stamps setupData (Colonial) and re-sizes the calc's q-procedure dynamic
// window. When n actually changed, the group's OTHER parameters need the same
// re-run, or their stage/limits stay stale until their next ingest.
//
// Returns the sibling parameters to re-run — [] when n is unchanged or the saved
// value is unknown (config not loaded yet), so an ordinary save costs nothing
// extra. The chart page's parameter list is built from every data doc with this
// shortKey, so it can include a restarted chart's archived history
// (`Sulfur_2026-09-01`) and the derived Combined Z-score; neither is re-run.
export function siblingParametersToRerun({
  savedInitialAssessment,
  nextInitialAssessment,
  parameters,
  currentParameter
}) {
  if (savedInitialAssessment === undefined || savedInitialAssessment === null) return [];
  if (String(savedInitialAssessment).trim() === String(nextInitialAssessment ?? '').trim()) {
    return [];
  }
  if (!Array.isArray(parameters)) return [];
  return [
    ...new Set(
      parameters.filter(
        (p) =>
          typeof p === 'string' &&
          p &&
          p !== currentParameter &&
          p !== COMBINED_PARAMETER_NAME &&
          !archiveRegex.test(p)
      )
    )
  ];
}

// Each runData call is a heavy callable (reads the key, runs the calc, writes
// docs + summary, sends notifications), so the fan-out runs one at a time; the
// loading spinner is already up. A failure is reported and the rest continue.
export async function runSequentially(items, task, onError) {
  for (const item of items) {
    try {
      // eslint-disable-next-line no-await-in-loop
      await task(item);
    } catch (error) {
      if (onError) onError(item, error);
    }
  }
}
